<template>
  <nav :class="['navbar', { 'scrolled': isScrolled }]">
    <div :class="['logo', { 'visible': isScrolled }]">
      <img src="../assets/img/logo-transparent.webp" />
    </div>

    <button class="hamburger" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <ul :class="['nav-links', { open: menuOpen }]">
      <li><a href="#home" @click="closeMenu">Home</a></li>
      <li><a href="#about" @click="closeMenu">About</a></li>
      <li><a href="#menu" @click="closeMenu">Menu</a></li>
      <li><a href="#services" @click="closeMenu">Services</a></li>
      <li><a href="#contact" @click="closeMenu">Contact</a></li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const menuOpen = ref(false)
const isScrolled = ref(false)

function toggleMenu() {
  menuOpen.value = !menuOpen.value
}

function closeMenu() {
  menuOpen.value = false
}

function handleScroll() {
  isScrolled.value = window.scrollY > 10
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  background-color: transparent;
  color: white;
}

.navbar.scrolled {
  background-color: rgba(0, 0, 0, 0.85);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.5s ease;
  height: 25px;
}

.logo img {
  height: 100%;
}

.logo.visible {
  opacity: 1;
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  background: none;
  border: none;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background-color: white;
  display: block;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 1.5rem;
}

.nav-links li a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 1rem;
  font-weight: bold;
}

.nav-links li:hover a {
  color: var(--primary);
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-links {
    display: none;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 1rem 2rem;
  }

  .nav-links.open {
    display: flex;
  }
}

/* Optional: add scroll offset for fixed navbar */
section {
  scroll-margin-top: 100px; /* Adjust based on navbar height */
}
</style>
